import { type PathOfProctorRequestCreationFormType } from './types';

export const PROCTOR_REQUEST_CREATION_FORM_FIELD_NAME = {
  proctorType: 'proctorType',
  personal: {
    idNumber: 'personal.idNumber',
    titleTh: 'personal.titleTh',
    firstNameTh: 'personal.firstNameTh',
    lastNameTh: 'personal.lastNameTh',
    titleEn: 'personal.titleEn',
    firstNameEn: 'personal.firstNameEn',
    lastNameEn: 'personal.lastNameEn',
    email: 'personal.email',
    phoneNumber: 'personal.phoneNumber',
    address: 'personal.address',
  },
  employeeInfo: {
    code: 'employeeInfo.code',
    position: 'employeeInfo.position',
    department: 'employeeInfo.department',
    startedAt: 'employeeInfo.startedAt',
    termination: {
      isAssigned: 'employeeInfo.termination.isAssigned',
      endedAt: 'employeeInfo.termination.endedAt',
    },
  },
  document: {
    agreementForms: 'document.agreementForms',
    identifications: 'document.identifications',
  },
} as const satisfies {
  proctorType: PathOfProctorRequestCreationFormType;
  personal: Record<string, PathOfProctorRequestCreationFormType>;
  employeeInfo: Record<
    string,
    PathOfProctorRequestCreationFormType | Record<string, PathOfProctorRequestCreationFormType>
  >;
  document: Record<string, PathOfProctorRequestCreationFormType>;
};
